import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import DashCard from './DashCard';
import RoomAvailability from '../MeetingRoom/RoomAvailabilty';
import BoxAvailability from '../MeetingRoom/BoxAvailability';

import * as actions from '../../actions/calendar';

/**
 * Display the meeting room availability.
 */
class MeetingRoomCard extends React.Component {
    componentDidMount() {
        this.props.fetchMeetingRoomAvailability();

        this.fetchMeetingRoom = setInterval(
            function() {
                this.props.fetchMeetingRoomAvailability();
            }.bind(this),
            60 * 1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.fetchMeetingRoom);
    }

    render() {
        const { meetingRoomAvailability } = this.props;

        return (
            <DashCard title="Meeting Rooms" className="meeting-rooms">
                <div>
                    {meetingRoomAvailability !== undefined &&
                        meetingRoomAvailability.availabilities.map(
                            (room, index) => (
                                <Fragment key={index}>
                                    {room.availabilities === undefined ? (
                                        <RoomAvailability
                                            room={room}
                                            key={index}
                                        />
                                    ) : (
                                        <BoxAvailability
                                            room={room}
                                            key={index}
                                        />
                                    )}
                                </Fragment>
                            )
                        )}
                </div>
            </DashCard>
        );
    }
}

function mapStateToProps(state) {
    return {
        meetingRoomAvailability: state.calendar.meetingRoomAvailability,
    };
}

export default connect(
    mapStateToProps,
    actions
)(MeetingRoomCard);



// WEBPACK FOOTER //
// ./src/components/Cards/MeetingRoomCard.js